/* eslint-disable import/order */
import React, { useState, useEffect, useRef, createRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import camelcaseKeys from 'camelcase-keys';
import LockCycle from '@src/assets/images/lock-cycle.svg';
import { EditorState, ContentState, CompositeDecorator } from 'draft-js';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useGrowthBook } from '@growthbook/growthbook-react';
import sanitizeHtml from 'sanitize-html';

import {
  LANGUAGE_CODE,
  REQUEST_STATUS,
  MAX_TRY_LISTENING_CHARACTERS,
  BREAK_TIME_REGEX,
  DEFAULT_SYNTHESIS_REQUEST,
  REGEX,
  ENGLISH_VOICE_CODES,
  VOICE_PROVIDER,
  BITRATE,
  VOICE_OWNERSHIP,
  OUTPUT_AUDIO,
} from '@src/constants/voice';
import { WS_TYPE, PING_INTERVAL } from '@src/constants/websocket';
import { RECAPTCHA_ENTERPRISE_SITE_KEY, TTS_SYNTHESIS_URL } from '@src/configs';
import {
  countTextLength,
  checkValidXml,
  checkFeaturePermission,
  countCreditsSynthesis,
  // countCreditsOfSentences,
  countTextLengthOfSentences,
} from '@src/services/tts';
import CrownImg from '@src/assets/images/crown.png';
import {
  newSplitParagraphIntoSentence,
  splitParagraphIntoSentence,
  getSentencesPayload,
  newGetSentencesPayload,
  convertSentenceToParagraphs,
} from '@src/services/sentence';
import { findWithRegexEditor, generateDecorator } from '@src/services/editor';
// import FEATURE_FLAG from '@src/constants/featureFlags.json';
import {
  getDataLocalStorage,
  deleteDataLocalStorage,
} from '@src/utils/localStorage';
import {
  convertParagraphsToText,
  checkSyntaxTagsParagraphs,
  convertTextToParagraphs,
  countCreditEditorStateLength,
  countEditorStateLength,
} from '@src/services/paragraph';

import Card from '@src/components/Card';
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { FEATURE_KEYS } from '@src/configs/featureKeys';

// import arrowIconDown from '@src/assets/icons/arrow-icon-down.png';
import ConfirmDialog from '@src/components/Dialog/ConfirmDialog';
import apis from '@src/apis';
import actions from '@src/redux/actions';
import ROUTES from '@src/constants/route';

import { checkVietNam } from '@src/utils/checkCountry';
import NotificationDialog from '@src/components/NotificationDialog';
import {
  DIALOG_V2_TYPE,
  EVENT_TYPE,
  MOBILE_BREAKPOINT,
  POPUP_TIME_OUT,
  SMS_IDENTITY_PROVIDER,
  ZERO_BREAK_TIME_REGEX,
} from '@src/constants';
import Decorator from '@src/components/Decorator';
import { TTS_GUIDE, TTS_TOUR_GUIDE } from '@src/constants/tourGuide';
// import Feature from '@src/components/Feature';
import {
  checkSyntaxTagsElements,
  convertElementsToText,
  getEntityStrategy,
} from '@src/services/entity';
import {
  VALID_SPEED,
  TTS_VERSION,
  VALID_CHARACTERS_LENGTH_REGEX,
  VALID_CHARACTERS_REGEX,
  PLAYING_AUDIO_TYPE,
  VOICE_VERSION,
  VALID_LETTERS,
  VALID_CHARACTERS_REGEX_SAFARI,
} from '@src/constants/tts';
import { ERROR_CODE } from '@src/errors/code';
import {
  FEATURE,
  FREE_PACKAGE_CODES,
  LIMITED_PREVIEW_PACKAGE_LEVEL,
  PACKAGE_CODE,
  PACKAGE_LEVEL,
  PACKAGE_LEVEL_V3,
  PACKAGE_STUDIO_VERSION,
} from '@src/constants/package';
import { RECAPTCHA_ACTION, RECAPTCHA_TYPE } from '@src/constants/recaptcha';
import {
  CLASS_WORD_BY_TYPE,
  REQUEST_TYPE,
  WARNING_REQUEST_TYPE,
} from '@src/constants/request';
import TrialPreviewImage from '@src/assets/icons/icon-preview.png';
import UpgradeImg from '@src/assets/images/space-shuttle.png';
import HightLightSpan from '@src/components/Decorator/HightLightSpan';
import ActionDialog from '@src/components/Dialog/ActionDialog';
import { BANNER_TYPE } from '@src/constants/banner';
import { isSameToday } from '@src/utils/time';
import useElementHeight from '@src/hooks/useElementHeight';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import useCustomKeycloak from '@src/hooks/useCustomKeycloak';
import VoicesDialog from '@src/components/VoicesDialog';
import datasenses from '@src/services/dataSenses';

import BreakTimeHighlight from '../TTS/BreakTimeHightLight';
import BlackWordHighLight from '../TTS/BlackWordHighLight';
import { StyledTTS } from './index.style';
import TitleBar from './TitleBar';
import ToolbarNew from './ToolbarNew';

import Content from './Content';
import NewRequest from './NewRequest';
import Requests from './Requests';
import AudioPlayer from '../AudioPlayer';
import NewTourGuide from '../NewTourGuide';
import NotificationDialogV4 from '@src/components/NotificationDialogV4';
import { VOICE_STATUS, VC_VOICE_CODE_REGEX } from '@src/constants/voiceCloning';
// import NotificationDialogV2 from '@src/components/NotificationDialogV2';
import VoicesDialogNew from '@src/components/VoicesDialogNew';
import { containsBlacklistedWords } from '@src/services/blackword';
import NotificationDialogV3 from '@src/components/NotificationDialogV3';
import { checkBrowser } from '@src/utils/browser';
import { validateUserPackageCanUseVoiceCloning } from '@src/services/voiceCloning';
import { checkCustomPackage, checkFreePackage } from '@src/services/package';
import useUserInfo from '@src/hooks/useTtsUser';
import AIEditor from './AiEditor';
import { StyledHightLightWord, TooltipWrapper } from './AiEditor/index.style';
import TitleBarNew from './TitileBarNew';
import OutOfCreditsFree from './OutOfCreditsAlert/OutOfCreditsFree';
import OutOfCreditsSpecial from './OutOfCreditsAlert/OutOfCreditsSpecial';
import OutOfCreditsStandard from './OutOfCreditsAlert/OutOfCreditsStandard';
import FreeMaxCharsLimitExceeded from './MaxCharsLimitExceeded/FreeMaxCharsLimitExceeded';
import PaidMaxCharsLimitExceeded from './MaxCharsLimitExceeded/PaidMaxCharsLimitExceeded';
import ExpiredPackageAlert from './ExpiredPackageAlert';
import { canUseEOLVoice, checkAdvancedGlobalVoice } from '@src/services/voice';
import OutOfCreditsVip from './OutOfCreditsAlert/OutOfCreditsVip';
import OutOfCreditsCustom from './OutOfCreditsAlert/OutOfCreditsCustom';
import useLocation from '@src/hooks/useLocation';

// import Requests from '../TTS/Requests';
// import SwitchAdvanceFeature from './SwitchAdvanceFeature';

const HEIGHT_LARGE_SCREEN = 900;
const OTHER_ELEMENT_HEIGHT = 175;
const WIDTH_SCREEN_SHOW_MORE_BTN = 1395;

const TTSNew = ({ isNewHomepage, onClickAddRequest }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { keycloak } = useCustomKeycloak();
  const audioRef = createRef();
  const growthbook = useGrowthBook();
  const { ip } = useLocation();

  const useOldSaveDraftFeatureFlag = growthbook.getFeatureValue(
    FEATURE_KEYS.OLD_AUTO_SAVE_DRAFT,
  );
  const user = useSelector((state) => state.auth.user);
  const { usingPackage } = useSelector((state) => state.user);
  const packageCode = usingPackage?.code;

  const { ttsUser } = useUserInfo();
  const { identityProvider } = useSelector((state) => state.auth.user);
  const isSMSUser = useMemo(
    () => Object.values(SMS_IDENTITY_PROVIDER).includes(identityProvider),
    [identityProvider],
  );
  const { getFeatureValue } = useFeatureFlags();

  const useNewDictionaryUI = getFeatureValue(FEATURE_KEYS.NEW_DICTIONARY_UI, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const useNewRequestUI = getFeatureValue(FEATURE_KEYS.NEW_REQUESTS_LAYOUT, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const useLoadingLoadRequest = getFeatureValue(
    FEATURE_KEYS.LOADING_LOAD_REQUEST,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );

  const isUseStreamingPreview = getFeatureValue(
    FEATURE_KEYS.STREAMING_PREVIEW,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );

  const isNewHateSpeechDetectorEnabled = getFeatureValue(
    FEATURE_KEYS.NEW_HATE_SPEECH_DETECTOR,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );

  const useNewTTSLayout = getFeatureValue(FEATURE_KEYS.NEW_TTS_LAYOUT, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const isSynthesisVoiceCloning =
    getFeatureValue(FEATURE_KEYS.VOICE_CLONING, {
      userId: user?.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    }) || validateUserPackageCanUseVoiceCloning(ttsUser);

  const canUserUseVoiceCloning = useMemo(
    () =>
      getFeatureValue(FEATURE_KEYS.VOICE_CLONING, {
        userId: user?.id,
        email: user.email,
        phoneNumber: user.phoneNumber,
      }) ||
      (validateUserPackageCanUseVoiceCloning(ttsUser) &&
        ttsUser?.packageExpiryDate &&
        moment().isBefore(ttsUser?.packageExpiryDate)),
    [ttsUser?.packageExpiryDate, isSynthesisVoiceCloning],
  );

  const useNewUXSynthesis = getFeatureValue(FEATURE_KEYS.NEW_UX_SYNTHESIS, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const useAIEditor = getFeatureValue(FEATURE_KEYS.AI_EDITTING, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const isNewPopupChooseVoise = getFeatureValue(
    FEATURE_KEYS.NEW_POPUP_CHOOSE_VOICE,
    {
      userId: user.id,
      email: user.email,
      phoneNumber: user.phoneNumber,
    },
  );

  const isNewHeaderUI = getFeatureValue(FEATURE_KEYS.NEW_HEADER_UI, {
    userId: user.id,
    email: user.email,
    phoneNumber: user.phoneNumber,
  });

  const useUserEolDate = getFeatureValue(
    FEATURE_KEYS.UPDATE_VOICES_BY_USER_EOL_DATE,
    {
      userId: user.id,
    },
  );
  const voiceHasBeenRenamed = getFeatureValue(
    FEATURE_KEYS.VOICE_HAS_BEEN_RENAMED,
    { userId: user.id, email: user.email, phoneNumber: user.phoneNumber, ip },
  );

  const ttsRef = useRef();
  const requestTableRef = useRef();
  const requestTableHeight =
    useElementHeight(requestTableRef) + OTHER_ELEMENT_HEIGHT;
  const [synthesisSentence, setSynthesisSentence] = useState('');
  const [openVoices, setOpenVoices] = useState(false);
  const [content, setContent] = useState(
    EditorState.createEmpty(
      generateDecorator(BREAK_TIME_REGEX, BreakTimeHighlight),
    ),
  );
  // const [voice, setVoice] = useState();
  const [runTourGuide, setRunTourGuide] = useState(false);
  const [inputLength, setInputLength] = useState(0);
  // const [openRequest, setOpenRequest] = useState(false);
  const [characterExceed, setCharacterExceed] = useState(false);

  const [confirmSwitchParagraph, setConfirmSwitchParagraph] = useState(false);
  const [isSSML, setIsSSML] = useState(false);
  const [openSSMLDialog, setOpenSSMLDialog] = useState(false);
  const [openWrongBreakTimeDialog, setOpenWrongBreakTimeDialog] =
    useState(false);
  const [openDialogLockedCycle, setOpenDialogLockedCycle] = useState(null);
  // TODO: change state name => openWarningDialog
  const [openWrongSyntaxDialog, setOpenWrongSyntaxDialog] = useState(null);
  const [openWrongSyntaxDialogV2, setOpenWrongSyntaxDialogV2] = useState(null);
  const [triggerBtn, setTriggerBtn] = useState(false);
  const [requestLoading, setRequestLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const [openDraft, setOpenDraft] = useState(false);
  const [loadDraft, setLoadDraft] = useState(false);

  const [flickerBackground, setFlickerBackground] = useState(false);
  const currentBrowser = checkBrowser();
  const [previewPayload, setPreviewPayload] = useState({});

  const [openMaxCharsLimitExceeded, setOpenMaxCharsLimitExceeded] =
    useState(false);
  const [actionDialog, setActionDialog] = useState();
  const [remainingPreview, setRemainingPreview] = useState(null);
  const [usedFreePreviews, setUsedFreePreviews] = useState(0);

  const [blackWords, setBlackWords] = useState([]);
  const [isExpandRequest, setIsExpandRequest] = useState();
  const [enableEditor, setEnableEditor] = useState(true);
  const [charsFactorCheckbox, setCharsFactorCheckbox] = useState(false);
  const [openOutOfCreditsDialog, setOpenOutOfCreditsDialog] = useState(false);
  const [openExpiredPackageDialog, setOpenExpiredPackageDialog] =
    useState(false);

  const [warningOneTimeCredits, setWarningOneTimeCredits] = useState(false);

  const screenHeight = window.innerHeight;
  const screenWidth = window.innerWidth;

  const runStreamAudioRef = useRef(false);

  const {
    isPlaying,
    requestPreviewId,
    audioType: playAudioType,
    isRunStreamAudio,
    showAudioPlayer,
  } = useSelector((state) => state.audioPlayer);
  const {
    synthesisRequest,
    paragraphs,
    sentences,
    openSentences,
    advanceFeature,
    voice,
    selectedSentences,
    loadingLoadRequest,
    loadingAIEditor,
    typeAICheck,
    wordsAIEditorChecked,
    skippedWord,
    showSample,
  } = useSelector((state) => state.synthesisRequest);

  const { seenAllBanner } = useSelector((state) => state.banner);
  const {
    user: {
      remainingCharacters,
      bonusCharacters,
      packageExpiryDate,
      hasAgreedToTerms,
    },
  } = useSelector((state) => state.auth);

  const { studio } = ttsUser;
  const { cycle, topUp, custom } = studio || {};
  let {
    remainingCredits: remainingCycleCredits = 0,
    // eslint-disable-next-line prefer-const
    isLocked: isCycleCreditLocked,
  } = cycle || {};
  let {
    remainingCredits: remainingTopUpCredits = 0,
    // eslint-disable-next-line prefer-const
    isLocked: isTopUpCreditLocked,
  } = topUp || {};
  let {
    remainingCredits: remainingCustomCredits = 0,
    // eslint-disable-next-line prefer-const
    isLocked: isCustomCreditLocked,
  } = custom || {};

  const { limitedFeature } = useSelector((state) => state.dialog);
  const { defaultGlobalVoice, filterVoice } = useSelector(
    (state) => state.voice,
  );
  const maxLengthInputText = ttsUser?.maxLengthInputText || 0;
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const ws = useRef(null);
  const currentIsPlayingAudio = useRef(null);
  const toolbarRef = useRef(null);
  const currentReqPreviewId = useRef(requestPreviewId);
  const dispatch = useDispatch();
  const history = useHistory();
  const TTSRef = useRef();
  const { isAudioLoading } = useSelector((state) => state.audioPlayer);

  const countCredits = useMemo(() => {
    let countLength;

    if (openSentences) {
      const detailSelectedSentences = sentences.filter((item) =>
        selectedSentences.includes(item.id),
      );
      const synthesisSentences = selectedSentences?.length
        ? detailSelectedSentences
        : sentences;

      const sumCreditSentence = (sum, item) => {
        const factor = item?.voice?.creditFactor || 1;
        return item.text ? sum + item.text.trim().length * factor : sum;
      };

      const countCreditsOfSentences = () => {
        const contentLength = synthesisSentences.reduce(sumCreditSentence, 0);

        return contentLength;
      };

      countLength = countCreditsOfSentences();
    } else if (advanceFeature)
      countLength = countCreditEditorStateLength({
        editorState: content,
        paragraphs,
        voice,
      });
    else {
      const text = content.getCurrentContent().getPlainText('\n');
      countLength = countCreditsSynthesis({
        text,
        voice,
      });
    }

    return countLength;
  }, [content, voice, sentences, advanceFeature, openSentences]);

  const stepsGuide = [
    {
      title: 'textInput',
      steps: [
        { name: 'enterContentHere', target: `#${TTS_GUIDE.ENTER_TEXT_HERE}` },
      ],
    },
    // Add step upload file or import url when use new tourguide and button show more is hidden
    ...(WIDTH_SCREEN_SHOW_MORE_BTN < screenWidth
      ? [
          {
            title: 'uploadFileOrImportUrl',
            steps: [
              {
                name: 'uploadFileOrImportUrlGuide',
                target: `#${TTS_GUIDE.UPLOAD_FILE_OR_IMPORT_URL}`,
              },
            ],
          },
        ]
      : []),
    {
      title: 'chooseVoiceGuide',
      steps: [
        {
          name: 'voiceAdjustmentGuide',
          target: `#${TTS_GUIDE.VOICE}`,
        },
      ],
    },
    {
      title: 'preview',
      steps: [
        {
          name: 'tryListeningGuide',
          target: `#${TTS_GUIDE.TRY_LISTENING}`,
        },
      ],
    },
    {
      title: 'textTransfer',
      steps: [{ name: 'convertTTSGuide', target: `#${TTS_GUIDE.CONVERT}` }],
    },
    ...[
      {
        title: 'history',
        steps: [
          {
            name: 'timeRequestGuide',
            target: `#${TTS_GUIDE.REQUESTS_TABLE}`,
          },
        ],
      },
    ],
  ];

  const handleOpenVoices = (value) => {
    const isClonedVoice = VC_VOICE_CODE_REGEX.test(voice?.code);
    dispatch(
      actions.voice.changeFilterVoice({
        ...filterVoice,
        voiceOwnership: isClonedVoice
          ? VOICE_OWNERSHIP.PERSONAL
          : VOICE_OWNERSHIP.VBEE,
      }),
    );

    setOpenVoices(value);
  };
  const handleCloseVoices = () => setOpenVoices(false);
  const handleChangeContent = (value) => setContent(value);
  const handleChangeInputLength = (value) => setInputLength(value);

  const handleCloseDraft = () => {
    setOpenDraft(false);
    deleteDataLocalStorage('dataDraft');
    dispatch(actions.synthesisRequest.updateSynthesisRequest('title', ''));
  };
  const handleOpenDraft = () => setOpenDraft(true);
  const handleLoadDraft = () => {
    setLoadDraft(true);
    setOpenDraft(false);
  };

  const handleChangeIsExpandRequest = () => {
    setIsExpandRequest(!isExpandRequest);
  };

  // const handleOpenRequest = (value) => setOpenRequest(value);
  const handleChangeCharacterExceed = (value) => setCharacterExceed(value);
  const handleChangeRequestLoading = (value) => setRequestLoading(value);
  const handleChangeSynthesisSentence = (value) => setSynthesisSentence(value);

  const handleChangeVoice = (value, loadingSynthesisConfig) => {
    // Update with normal voice
    if (synthesisRequest?.voice?.code !== value?.code && !enableEditor) {
      setEnableEditor(true);
      if (!useNewUXSynthesis) {
        dispatch(
          actions.synthesisRequest.cloneSynthesisRequest(useNewUXSynthesis),
        );
      }
      if (useNewUXSynthesis && !openSentences) {
        dispatch(
          actions.synthesisRequest.cloneSynthesisRequest(useNewUXSynthesis),
        );
      }
    }

    dispatch(actions.synthesisRequest.updateVoice(value));
    if (
      value?.version !== TTS_VERSION.EMPHASIS &&
      voice?.version !== TTS_VERSION.EMPHASIS
    )
      return;

    if (
      value?.code !== voice?.code &&
      !openSentences &&
      !loadingSynthesisConfig
    ) {
      let newParagraphs = [];
      let convertText = '';
      const isAdvanceFeature = value?.version === TTS_VERSION.EMPHASIS;
      if (isAdvanceFeature) {
        convertText = content.getCurrentContent().getPlainText('\n');
        newParagraphs = convertTextToParagraphs(convertText);
      } else {
        const text = convertParagraphsToText(paragraphs);
        convertText = text
          ?.replace(REGEX.EMPHASIS_TAG, '')
          ?.replace(
            REGEX.ADVANCE_BREAK_TIME_TAG,
            (p1, p2) => `<break time=${p2}s/>`,
          );
      }

      const { id, status, createdAt, endedAt, progress, ...rest } =
        synthesisRequest;
      const newSynthesisRequest =
        synthesisRequest?.voice?.code !== value?.code ? rest : synthesisRequest;

      const newSynthesisConfig = {
        ...newSynthesisRequest,
        paragraphs: newParagraphs,
        text: convertText,
        voice: value,
        characters: inputLength,
        sentences: [],
      };

      dispatch(
        actions.synthesisRequest.updateSynthesisConfig(newSynthesisConfig),
      );
      dispatch(actions.synthesisRequest.updateLoadingSynthesisConfig(true));
    }

    // Update with emphasis voice
    if (synthesisRequest?.voice?.code !== value?.code && !enableEditor) {
      setEnableEditor(true);
      dispatch(
        actions.synthesisRequest.cloneSynthesisRequest(useNewUXSynthesis),
      );
    }
  };

  const handleChangeIsSSML = (value) => setIsSSML(value);
  const handleChangeOpenWrongBreakTimeDialog = (value) =>
    setOpenWrongBreakTimeDialog(value);

  const handleChangeRunTourGuide = (value) => {
    setRunTourGuide(value);
    dispatch(actions.user.isRunningTourGuide(value));
  };

  const handleCloseMaxCharsLimitExceededDialog = () =>
    setOpenMaxCharsLimitExceeded(false);

  const handleCloseOutOfCreditsDialog = () => setOpenOutOfCreditsDialog(false);

  const handleCloseExpiredPackageDialog = () => {
    setOpenExpiredPackageDialog(false);
  };

  const handleOpenSentences = (checkedSwitch) => {
    if (checkedSwitch) {
      dispatch(actions.synthesisRequest.updateOpenSentences(checkedSwitch));
      let newSentences;

      if (advanceFeature) {
        newSentences = newSplitParagraphIntoSentence(paragraphs, voice);
        dispatch(actions.synthesisRequest.updateParagraphs([]));
      } else {
        const plainTextContent = content.getCurrentContent().getPlainText('\n');
        newSentences = splitParagraphIntoSentence(plainTextContent, voice);
      }

      dispatch(actions.synthesisRequest.updateSentences(newSentences));
    } else {
      setConfirmSwitchParagraph(true);
    }
  };

  const handleCloseConfirmDialog = () => setConfirmSwitchParagraph(false);
  const handleCloseSSMLDialog = () => setOpenSSMLDialog(false);
  const handleCloseActionDialog = () => setActionDialog();
  const handleCloseLimitedFeatureDialog = () => {
    dispatch(actions.dialog.displayDialog({ limitedFeature: false }));
    handleCloseActionDialog();
  };

  const handleEnableEditor = (value) => setEnableEditor(value);

  const handleUpgradeNow = () => {
    dispatch(actions.user.updateShowBlockDownloadDialog(false));
    history.push(ROUTES.PAYMENT);
  };
  const renderUpgradeButton = () => (
    <Button variant="contained" onClick={handleUpgradeNow}>
      {t('upgradeNow')}
    </Button>
  );

  const renderLockedCycleButton = () => (
    <Button variant="contained" onClick={() => setOpenDialogLockedCycle(null)}>
      {t('understoodV3')}
    </Button>
  );

  const handleAcceptConfirmDialog = () => {
    dispatch(actions.synthesisRequest.updateOpenSentences(false));
    setConfirmSwitchParagraph(false);

    if (advanceFeature) {
      const newParagraphs = convertSentenceToParagraphs(sentences);
      dispatch(actions.synthesisRequest.updateParagraphs(newParagraphs));
      dispatch(actions.synthesisRequest.updateLoadingParagraphs(true));
    } else {
      const sentencesText = sentences.map((item) => item.text);
      const paragraphText = sentencesText.join('\n');

      const paragraphEditorStyle = EditorState.createWithContent(
        ContentState.createFromText(paragraphText),
        generateDecorator(BREAK_TIME_REGEX, BreakTimeHighlight),
      );
      setContent(paragraphEditorStyle);
    }
  };

  const handleLoadContentEditor = (
    sentencesSave,
    isAdvanceFeature,
    isOpenSentences,
    isEnableEditor,
  ) => {
    setLoadDraft(false);
    setEnableEditor(isEnableEditor);
    if (isOpenSentences) {
      const newSentences = sentencesSave.filter(
        (item) => !selectedSentences.includes(item.id),
      );
      dispatch(actions.synthesisRequest.updateSentences(newSentences));
      return;
    }
    if (!isOpenSentences) {
      if (!isAdvanceFeature) {
        const sentencesText = sentencesSave.map((item) => item.text);
        const paragraphText = sentencesText.join('\n');
        const paragraphEditorStyle = EditorState.createWithContent(
          ContentState.createFromText(paragraphText),
          generateDecorator(BREAK_TIME_REGEX, BreakTimeHighlight),
        );
        setContent(paragraphEditorStyle);
      }
      if (isAdvanceFeature) {
        dispatch(actions.synthesisRequest.switchAdvanceFeature(true));
        dispatch(
          actions.synthesisRequest.updateSynthesisRequest(
            'paragraphs',
            sentencesSave,
          ),
        );
      }
    }
  };

  const checkValidatePreviewSentence = (sentence) => {
    const {
      elements,
      previewParagraphs,
      voice: sentenceVoice,
      speed,
    } = sentence;

    const isExpiredPackage =
      packageExpiryDate && moment().isAfter(packageExpiryDate);

    if (isExpiredPackage) {
      setOpenExpiredPackageDialog(true);
      return { error: true };
    }
    let text;
    if (advanceFeature) {
      const { error, detailError } = openSentences
        ? checkSyntaxTagsElements(elements)
        : checkSyntaxTagsParagraphs(previewParagraphs, sentenceVoice?.provider);

      if (error) {
        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('errorSyntax'),
          description: t('errorSyntaxDescription'),
          subDescription: t(detailError),
        });
        return { error: true };
      }
      text = openSentences
        ? convertElementsToText(elements)
        : convertParagraphsToText(previewParagraphs);
      if (BREAK_TIME_REGEX.test(text)) {
        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('errorSyntax'),
          description: t('errorSyntaxDescription'),
          subDescription: t('invalidBreakTime'),
        });
        return { error: true };
      }
    } else {
      text = sentence?.text;
    }

    if (!text || !text.trim()) {
      setOpenWrongSyntaxDialog({
        name: 'error-syntax',
        variant: 'warning',
        title: t('errorSyntax'),
        description: t('errorSyntaxDescription'),
      });
      return { error: true };
    }

    const plainText = text
      .replace(REGEX.ADVANCE_TAG, '')
      .replace(BREAK_TIME_REGEX, ' ')
      .replace(/  +/g, ' ');
    const blackWordsInText = blackWords.filter((blackWord) =>
      containsBlacklistedWords({
        text: plainText,
        blackWord,
        isNewHateSpeechDetectorEnabled,
      }),
    );
    if (blackWordsInText.length > 0) {
      const blackWordsInTextRegex = blackWordsInText.map((blackWord) =>
        blackWord.replaceAll(' ', ' +'),
      );
      const regex = !currentBrowser?.safariAgent
        ? new RegExp(
            `(?<![${VALID_LETTERS}])(${blackWordsInTextRegex.join(
              '|',
            )})(?![${VALID_LETTERS}])`,
            'gi',
          )
        : new RegExp(
            `(^|[^${VALID_LETTERS}])(${blackWordsInTextRegex.join(
              '|',
            )})([^${VALID_LETTERS}]|$)`,
            'gi',
          );

      const stateContent = EditorState.set(content, {
        decorator: new CompositeDecorator([
          {
            strategy: (contentBlock, callback) => {
              findWithRegexEditor(regex, contentBlock, callback);
            },
            component: BlackWordHighLight,
          },
          {
            strategy: getEntityStrategy('MUTABLE'),
            component: HightLightSpan,
          },
        ]),
      });
      handleChangeContent(stateContent);

      apis.warning.sendWarningInvalidRequest({
        text,
        invalidTexts: blackWordsInText,
        type: WARNING_REQUEST_TYPE.BLACK_WORD,
      });

      setOpenWrongSyntaxDialog({
        name: 'error-syntax',
        variant: 'warning',
        title: t('sentenceHasBlackWords'),
        description: t('sentenceHasBlackWordsDescription'),
      });
      return { error: true };
    }

    if (sentenceVoice?.provider === VOICE_PROVIDER.VBEE) {
      const invalidTexts = text.match(VALID_CHARACTERS_LENGTH_REGEX) || [];
      const isValidText = VALID_CHARACTERS_REGEX.test(text);
      if (!isValidText) invalidTexts.push(text);

      if (invalidTexts?.length) {
        const invalidText = invalidTexts.join(', ');
        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('errorSyntax'),
          description: t('errorSyntaxDescription'),
          subDescription: t('invalidCharacter', { invalidText }),
        });
        apis.warning.sendWarningInvalidRequest({
          text,
          invalidTexts,
          type: WARNING_REQUEST_TYPE.CHARACTER_EXCEED,
        });
        return { error: true };
      }
    }

    const invalidSpeed = speed < VALID_SPEED.min || speed > VALID_SPEED.max;
    if (invalidSpeed) {
      dispatch(
        actions.noti.push({
          severity: 'warning',
          message: 'speedInvalidRange',
          value: t('range', {
            min: `${VALID_SPEED.min}x`,
            max: `${VALID_SPEED.max}x`,
          }),
        }),
      );
      return { error: true };
    }

    const regex = advanceFeature ? REGEX.ADVANCE_TAG : BREAK_TIME_REGEX;
    const countLength = countTextLength(text, regex);
    const maxTryListeningCharacters =
      ttsUser.maxLengthDemoInput || MAX_TRY_LISTENING_CHARACTERS;
    if (!countLength || countLength > maxTryListeningCharacters) {
      dispatch(
        actions.noti.push({
          severity: 'warning',
          message: 'warningListening',
          value: maxTryListeningCharacters,
        }),
      );
      return { error: true };
    }
    return { error: false, previewData: { ...sentence, text } };
  };

  const handlePreviewSentence = (sentence) => {
    const { error, previewData } = checkValidatePreviewSentence(sentence);
    if (error) return;

    const { id: sentenceId, text, voice: sentenceVoice, speed } = previewData;

    dispatch(
      actions.audioPlayer.updatePreviewRequestInfo({
        voice,
        title: t('preview'),
      }),
    );
    dispatch(actions.audioPlayer.updateShowAudioPlayer(true));

    const checkEmphasisInText = REGEX.ADVANCE_TAG.test(text);
    const suitableVersion = checkEmphasisInText
      ? VOICE_VERSION.ADVANCE
      : VOICE_VERSION.NORMAL;

    dispatch(actions.audioPlayer.updateAudioLink(''));
    dispatch(actions.audioPlayer.updateSelectedAudioRequest(''));
    dispatch(actions.audioPlayer.updateStatus(false));
    dispatch(actions.audioPlayer.updateStatusStreamAudio(false));
    dispatch(
      actions.audioPlayer.initStreamAudios(
        suitableVersion || sentenceVoice?.version,
      ),
    );
    dispatch(actions.audioPlayer.updateAudioType(PLAYING_AUDIO_TYPE.SILENCE));
    dispatch(
      actions.audioPlayer.updateMetaData({ currentTime: 0, duration: 0 }),
    );
    dispatch(
      actions.audioPlayer.updateTryListeningSentence({
        isAudioLoading: true,
        sentenceId,
      }),
    );

    const { audioType, bitrate, backgroundMusic, volume } = synthesisRequest;

    const payload = {
      text,
      voiceCode: sentenceVoice?.code,
      speed,
      audioType,
      volume,
    };

    if (advanceFeature) {
      payload.bitrate = bitrate;
      payload.version = TTS_VERSION.EMPHASIS;
    } else {
      payload.bitrate = bitrate;
    }

    const hasBackgroundMusic =
      backgroundMusic && Object.keys(backgroundMusic).length;
    if (hasBackgroundMusic) {
      const { link, name, volume: bgVolume } = backgroundMusic;
      payload.backgroundMusic = { link, name, volume: bgVolume };
    }

    const isStandardData = getFeatureValue(
      FEATURE_KEYS.STANDARDIZATION_USER_DATA_MOE,
    );

    if (!isStandardData)
      window.dataLayer.push({
        event: EVENT_TYPE.STUDIO_PREVIEW_TTS,
        userId: user?.id,
        email: user.email,
        requestType: 'Preview',
        voice: sentenceVoice?.name,
        characters: payload.text?.length || 0,
        package: user.packageCode,
        remainingCharacters: user.remainingCharacters,
        packageExpiryDate: moment(user.packageExpiryDate).format(
          'DD/MM/YYYY - HH:mm',
        ),
      });
    payload.datasenses = datasenses.getDataSensesRequireFields();
    setPreviewPayload(payload);
  };

  const handlePreviewTrialAction = (previewSentence) => {
    handlePreviewSentence(previewSentence);
    handleCloseActionDialog();
  };

  const checkVoicePermission = () => {
    const isVietNam = checkVietNam();
    const isDefaultGlobalVoice =
      !isVietNam &&
      usingPackage?.level === PACKAGE_LEVEL.BASIC &&
      voice?.code === defaultGlobalVoice;

    return (
      !voice?.features?.length ||
      isDefaultGlobalVoice ||
      voice.features.every((item) =>
        checkFeaturePermission(ttsUser.features, item),
      ) ||
      (canUseEOLVoice({ voice, user }) && useUserEolDate)
    );
  };

  const checkOutputAudioTypePermission = () => {
    const isPackageV2 =
      usingPackage?.version === PACKAGE_STUDIO_VERSION.V2 ||
      usingPackage?.version === PACKAGE_STUDIO_VERSION.V2_1;
    if (!isPackageV2) return true;
    if (!synthesisRequest?.audioType) return true;
    const ouputAudio = OUTPUT_AUDIO.find(
      (item) => item.type === synthesisRequest?.audioType,
    );
    const hasFeature = checkFeaturePermission(
      ttsUser?.features,
      ouputAudio?.feature,
    );
    return hasFeature;
  };

  const checkConditionPackageToPreview = (sentence) => {
    const isRenameVoice =
      voiceHasBeenRenamed && !voice?.active && !!voice?.canonicalVoice?.name;

    if (isRenameVoice) {
      setOpenWrongSyntaxDialogV2({
        name: 'error-syntax',
        variant: 'none',
        title: t('notice'),
        description: sanitizeHtml(
          t('voiceHasBeenRenamed', {
            newName: synthesisRequest?.voice?.canonicalVoice?.name,
          }),
          {
            allowedTags: ['strong'],
          },
        ),
        type: DIALOG_V2_TYPE.RENAME_VOICE,
      });
      return;
    }
    if (!ttsUser.features.includes(FEATURE.PREVIEW)) {
      setActionDialog({
        image: UpgradeImg,
        title: t('premiumFeature'),
        description: t('premiumFeatureDescription'),
        onClose: handleCloseActionDialog,
        actionComponents: renderUpgradeButton(),
      });
      return;
    }

    if (
      !canUserUseVoiceCloning &&
      voice?.provider === VOICE_PROVIDER.VBEE_VOICE_CLONING
    ) {
      dispatch(
        actions.limitedFeaturesDialog.showLimitedFeaturesDialog({
          description: t('voiceCloningUpgrade'),
          img: CrownImg,
          classNameImg: 'custom-img',
          onUpgrade: () => {
            history.push(
              `${ROUTES.PAYMENT}?package=${PACKAGE_CODE.STUDIO_ENTERPRISE_YEAR_V2}`,
            );
            dispatch(actions.limitedFeaturesDialog.hideLimitedFeaturesDialog());
          },
        }),
      );
      return;
    }

    if (LIMITED_PREVIEW_PACKAGE_LEVEL.includes(usingPackage.level)) {
      if (!remainingPreview)
        setActionDialog({
          image: UpgradeImg,
          title: t('previewOver'),
          description: t('previewOverDescription'),
          onClose: handleCloseActionDialog,
          actionComponents: renderUpgradeButton(),
        });
      else {
        setActionDialog({
          image: TrialPreviewImage,
          title: t('previewTrial', { remainingPreview }),
          description: t('previewTrialDescription'),
          onClose: handleCloseActionDialog,
          actionComponents: (
            <>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleCloseActionDialog}
              >
                {t('noValue')}
              </Button>
              <Button
                variant="contained"
                onClick={() => handlePreviewTrialAction(sentence)}
              >
                {t('preview')}
              </Button>
            </>
          ),
        });
      }
      return;
    }

    if (
      ttsUser?.packageCode &&
      checkFreePackage(ttsUser?.packageCode) &&
      ttsUser?.maxPreview &&
      usedFreePreviews >= ttsUser?.maxPreview
    ) {
      dispatch(
        actions.limitedFeaturesDialog.showLimitedFeaturesDialog({
          description: t('trialEndedMessage'),
          img: CrownImg,
          classNameImg: 'custom-img',
          onUpgrade: () => {
            history.push(ROUTES.PAYMENT);
            dispatch(actions.limitedFeaturesDialog.hideLimitedFeaturesDialog());
          },
        }),
      );
      return;
    }

    const canUseVoice = checkVoicePermission();
    if (!canUseVoice) {
      dispatch(
        actions.noti.push({
          severity: 'warning',
          message: 'limitedVoiceDescription',
        }),
      );
      return;
    }

    handlePreviewSentence(sentence);
  };

  const getTextLength = () => {
    let countLength;

    if (openSentences) {
      const detailSelectedSentences = sentences.filter((item) =>
        selectedSentences.includes(item.id),
      );
      const synthesisSentences = selectedSentences?.length
        ? detailSelectedSentences
        : sentences;

      countLength = countTextLengthOfSentences(synthesisSentences);
    } else if (advanceFeature)
      countLength = countEditorStateLength(content, paragraphs);
    else {
      const text = content.getCurrentContent().getPlainText('\n');
      const regex = advanceFeature ? REGEX.ADVANCE_TAG : BREAK_TIME_REGEX;
      countLength = countTextLength(text, regex);
    }

    return countLength;
  };

  const openLimitedFeatureDialog = (featureKey) => {
    dispatch(
      actions.limitedFeaturesDialog.showLimitedFeaturesDialog({
        description: t('limitedFeatureDesc', { feature: t(featureKey) }),
      }),
    );
  };

  const checkValidCreateSynthesis = () => {
    const canUseVoice = checkVoicePermission();
    const canOutputAudioType = checkOutputAudioTypePermission();

    const isRenameVoice =
      voiceHasBeenRenamed && !voice?.active && !!voice?.canonicalVoice?.name;

    if (isRenameVoice) {
      setOpenWrongSyntaxDialogV2({
        name: 'error-syntax',
        variant: 'none',
        title: t('notice'),
        description: sanitizeHtml(
          t('voiceHasBeenRenamed', {
            newName: synthesisRequest?.voice?.canonicalVoice?.name,
          }),
          {
            allowedTags: ['strong'],
          },
        ),
        type: DIALOG_V2_TYPE.RENAME_VOICE,
      });
      return false;
    }
    // Check audio type
    if (!canOutputAudioType) {
      openLimitedFeatureDialog(
        OUTPUT_AUDIO.find((item) => item.type === synthesisRequest.audioType)
          ?.featureDesc,
      );
      return false;
    }
    // Check voice
    if (!canUseVoice) {
      openLimitedFeatureDialog('useThisVoice');
      return false;
    }

    // Check input text length
    const countLength = getTextLength();
    if (!countCredits) return false;
    if (countLength > maxLengthInputText) {
      setOpenMaxCharsLimitExceeded(true);
      return false;
    }

    // Check package expired
    const isExpiredPackage =
      packageExpiryDate && moment().isAfter(packageExpiryDate);

    if (isExpiredPackage) {
      setOpenExpiredPackageDialog(true);
      return false;
    }

    const isLockedCycle =
      isCycleCreditLocked &&
      !remainingTopUpCredits &&
      !remainingCharacters &&
      !bonusCharacters;

    const isLockedTopUp =
      isTopUpCreditLocked && !remainingCharacters && !bonusCharacters;

    if (isLockedCycle || isLockedTopUp) {
      setOpenDialogLockedCycle({
        title: t('charactersTemporarilyLocked'),
        description: t('descriptionPopupLockedCredit'),
      });
      return false;
    }

    let usageRemainingCharacters = remainingCharacters;
    if (isCycleCreditLocked) remainingCycleCredits = 0;
    if (isTopUpCreditLocked) remainingTopUpCredits = 0;
    if (isCustomCreditLocked) remainingCustomCredits = 0;

    // handle normal synthesis
    if (!openSentences) {
      const useLockOneTimeCreditsAdvancedVoice = getFeatureValue(
        FEATURE_KEYS.LOCK_ONE_TIME_CREDITS_ADVANCED_VOICE,
        { userId: user.id, voiceCode: voice?.code, voiceName: voice?.name },
      );
      const isAdvancedGlobalVoice = checkAdvancedGlobalVoice(voice);

      if (isAdvancedGlobalVoice && useLockOneTimeCreditsAdvancedVoice)
        usageRemainingCharacters = 0;
    } else {
      // TODO: get text length of global advanced voice in sentence and reduce remaining character
      // handle open sentences synthesis
      const blockAdvancedGlobalVoice = sentences.some((sentence) => {
        const useLockOneTimeCreditsAdvancedVoice = getFeatureValue(
          FEATURE_KEYS.LOCK_ONE_TIME_CREDITS_ADVANCED_VOICE,
          {
            userId: user.id,
            voiceCode: sentence?.voice?.code,
            voiceName: sentence?.voice?.name,
          },
        );
        return (
          checkAdvancedGlobalVoice(sentence.voice) &&
          useLockOneTimeCreditsAdvancedVoice
        );
      });

      if (blockAdvancedGlobalVoice) usageRemainingCharacters = 0;
    }

    const totalCredits =
      usageRemainingCharacters +
      bonusCharacters +
      remainingCycleCredits +
      remainingTopUpCredits +
      remainingCustomCredits;
    // TODO: check feature flag for this condition if rollback to old version
    if (countCredits > totalCredits) {
      if (remainingCharacters > 0 && usageRemainingCharacters === 0)
        setWarningOneTimeCredits(true);
      setOpenOutOfCreditsDialog(true);
      return false;
    }

    const isNotUsingPackage = !usingPackage.id;
    if (isNotUsingPackage) {
      setActionDialog({
        image: UpgradeImg,
        title: t('noPackage'),
        description: t('noteNoPackage'),
        onClose: handleCloseActionDialog,
        actionComponents: renderUpgradeButton(),
      });
      return false;
    }

    const { speed } = synthesisRequest;

    const invalidSpeed =
      !openSentences && (speed < VALID_SPEED.min || speed > VALID_SPEED.max);
    if (invalidSpeed) {
      dispatch(
        actions.noti.push({
          severity: 'warning',
          message: 'speedInvalidRange',
          value: t('range', {
            min: `${VALID_SPEED.min}x`,
            max: `${VALID_SPEED.max}x`,
          }),
        }),
      );
      return false;
    }
    return true;
  };

  const handleResetContentEditor = () => {
    setInputLength(0);
    deleteDataLocalStorage(`dataDraft-${user.id}`);
    dispatch(actions.synthesisRequest.updateSynthesisRequest('title', ''));
    if (openSentences) {
      const { voice: sentenceVoice = {} } = sentences[0];
      const initSentences = splitParagraphIntoSentence('', sentenceVoice);

      dispatch(actions.synthesisRequest.updateSentences(initSentences));
      dispatch(actions.synthesisRequest.updateSelectedSentences([]));

      return;
    }

    dispatch(actions.synthesisRequest.updateParagraphs([]));
    if (advanceFeature) {
      setContent(EditorState.createEmpty(Decorator));
      return;
    }
    setContent(
      EditorState.createEmpty(
        generateDecorator(BREAK_TIME_REGEX, BreakTimeHighlight),
      ),
    );
  };

  const handleCreateNewEditor = (isNew) => {
    handleEnableEditor(true);
    const {
      status,
      id,
      endedAt,
      processingAt,
      progress,
      title,
      ...newSynthesisRequest
    } = synthesisRequest;
    dispatch(
      actions.synthesisRequest.updateSynthesisConfig(newSynthesisRequest),
    );
    if (isNew) handleResetContentEditor();
  };

  const generateVoiceSummary = (voices) => {
    if (!Array.isArray(voices) || voices.length === 0) {
      return "<ul style='margin: 0 0 0 10px; padding: 0;'>\n<li>No voices available.</li>\n</ul>";
    }

    const voiceList = voices
      .map((item) => {
        const voiceName = item.name;
        const voiceLevel = t(item.level);
        const isBeta = item.beta ? ' - Beta' : '';
        const factor = item.creditFactor || 1;
        return t('voiceFactor', { voiceName, voiceLevel, isBeta, factor });
      })
      .join('\n');

    return t('totalFactorCredits', {
      voiceList,
      countCredits: countCredits?.toLocaleString(language),
    });
  };

  const showWarningCannotUseVoiceDialog = () => {
    setOpenWrongSyntaxDialogV2({
      name: 'error-syntax',
      variant: 'warning',
      title: t('notice'),
      description: sanitizeHtml(
        t('eolVoiceoverHasBeenDiscontinued', { voiceName: voice.name }),
        {
          allowedTags: ['p', 'strong'],
          allowedAttributes: {
            '*': ['style'],
          },
        },
      ),
      type: DIALOG_V2_TYPE.CANNOT_USE_VOICE,
    });
  };

  const showWarningFactorCharcterDialog = () => {
    const processSentences = selectedSentences?.length
      ? selectedSentences
      : sentences;
    const highCreditFactorVoices = openSentences
      ? processSentences
          .filter((sentence) => sentence?.voice?.creditFactor > 1)
          .map((sentence) => sentence?.voice)
      : [voice]?.filter((v) => v?.creditFactor > 1);

    const highCreditFactorVoicesUnique = highCreditFactorVoices.filter(
      (currVoice, index, self) =>
        index ===
        self.findIndex(
          (tVoice) =>
            tVoice.code === currVoice.code &&
            tVoice.provider === currVoice.provider,
        ),
    );

    if (!highCreditFactorVoicesUnique.length) return;
    setOpenWrongSyntaxDialogV2({
      name: 'error-syntax',
      variant: 'warning',
      title: t('note'),
      description: generateVoiceSummary(highCreditFactorVoicesUnique),
      type: DIALOG_V2_TYPE.NON_VBEE_WARNING,
    });
  };

  const checkVoiceFactorGreaterThanOne = () => {
    const voiceCredits = voice?.creditFactor || 1;
    if (!openSentences && voiceCredits > 1) return true;

    // Voice factor greater than 1
    const processSentences = selectedSentences?.length
      ? selectedSentences
      : sentences;
    const hasHighVoiceFactor = processSentences.some(
      (sentence) => (sentence?.voice?.creditFactor || 1) > 1,
    );
    if (hasHighVoiceFactor && openSentences) return true;

    return false;
  };

  // TODO: change name => showCharsFactorWarning
  const showNonVbeeWarning = useMemo(() => {
    let charsFactorDialog = localStorage.getItem('charsFactorDialog');
    charsFactorDialog = charsFactorDialog || charsFactorCheckbox;
    const useVoiceFactorGreaterThanOne = checkVoiceFactorGreaterThanOne();
    return useVoiceFactorGreaterThanOne && !charsFactorDialog;
  }, [charsFactorCheckbox, voice, sentences]);

  const createSynthesisRequest = async () => {
    const { title, audioType, bitrate, backgroundMusic, volume } =
      synthesisRequest;
    const detailSelectedSentences = sentences.filter((item) =>
      selectedSentences.includes(item.id),
    );
    const synthesisSentences = selectedSentences?.length
      ? detailSelectedSentences
      : sentences;
    let synthesisPayload = { audioType, volume };
    if (advanceFeature) {
      synthesisPayload.bitrate = bitrate || BITRATE[BITRATE.length - 1];
    } else {
      synthesisPayload.bitrate = bitrate || BITRATE[BITRATE.length - 1];
    }

    if (title) synthesisPayload.title = title.trim();

    const hasBackgroundMusic =
      backgroundMusic && Object.keys(backgroundMusic).length;
    if (hasBackgroundMusic) {
      const { link, name, volume: bgVolume } = backgroundMusic;
      synthesisPayload.backgroundMusic = { link, name, volume: bgVolume };
    }
    if (advanceFeature) {
      synthesisPayload.version = TTS_VERSION.EMPHASIS;
      const needCheckParagraphs = openSentences
        ? synthesisSentences
        : paragraphs;

      const { error, detailError } =
        checkSyntaxTagsParagraphs(needCheckParagraphs);
      if (error) {
        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('errorSyntax'),
          description: t('errorSyntaxDescription'),
          subDescription: t(detailError),
        });
        return;
      }
    }

    if (openSentences) {
      let sentencesPayload;
      if (advanceFeature) {
        sentencesPayload = newGetSentencesPayload(synthesisSentences);
        const invalidBreakTime = sentencesPayload.some((sentence) =>
          BREAK_TIME_REGEX.test(sentence.text),
        );
        if (invalidBreakTime) {
          setOpenWrongSyntaxDialog({
            name: 'error-syntax',
            variant: 'warning',
            title: t('errorSyntax'),
            description: t('errorSyntaxDescription'),
            subDescription: t('invalidBreakTime'),
          });
          return;
        }
      } else {
        sentencesPayload = getSentencesPayload(synthesisSentences);
        const hasZeroBreakTime = synthesisSentences.some((sentence) =>
          ZERO_BREAK_TIME_REGEX.test(sentence.text),
        );
        if (hasZeroBreakTime) {
          handleChangeOpenWrongBreakTimeDialog(true);
          return;
        }
      }
      const invalidTexts = sentencesPayload.reduce((acc, curr) => {
        const { text, voiceProvider } = curr;

        if (voiceProvider === VOICE_PROVIDER.VBEE) {
          const invalidSentenceText = text.match(VALID_CHARACTERS_LENGTH_REGEX);
          if (invalidSentenceText?.length) return invalidSentenceText;
          const isValidText = VALID_CHARACTERS_REGEX.test(text);
          if (!isValidText) return [text];
        }

        return acc;
      }, []);
      if (invalidTexts.length) {
        const invalidText = invalidTexts.join(', ');
        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('errorSyntax'),
          description: t('errorSyntaxDescription'),
          subDescription: t('invalidCharacter', { invalidText }),
        });
        const text = sentencesPayload
          .map((sentence) => sentence.text)
          .join('\n');
        apis.warning.sendWarningInvalidRequest({
          text,
          invalidTexts,
          type: WARNING_REQUEST_TYPE.CHARACTER_EXCEED,
        });

        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('sentenceHasBlackWords'),
          description: t('sentenceHasBlackWordsDescription'),
        });
        return;
      }
      // validate black words in sentences when open sentences
      const text = sentencesPayload.map((sentence) => sentence.text).join('\n');
      const plainText = text
        .replace(REGEX.ADVANCE_TAG, '')
        .replace(BREAK_TIME_REGEX, ' ')
        .replace(/  +/g, ' ');
      const blackWordsInText = blackWords.filter((blackWord) =>
        containsBlacklistedWords({
          text: plainText,
          blackWord,
          isNewHateSpeechDetectorEnabled,
        }),
      );
      if (blackWordsInText.length > 0) {
        dispatch(
          actions.synthesisRequest.updateBlackWordsInText(blackWordsInText),
        );

        apis.warning.sendWarningInvalidRequest({
          text,
          invalidTexts: blackWordsInText,
          type: WARNING_REQUEST_TYPE.BLACK_WORD,
        });

        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('sentenceHasBlackWords'),
          description: t('sentenceHasBlackWordsDescription'),
        });
        return;
      }
      synthesisPayload = { ...synthesisPayload, sentences: sentencesPayload };
    } else {
      let text;

      if (advanceFeature) {
        text = convertParagraphsToText(paragraphs);
        if (BREAK_TIME_REGEX.test(text)) {
          setOpenWrongSyntaxDialog({
            name: 'error-syntax',
            variant: 'warning',
            title: t('errorSyntax'),
            description: t('errorSyntaxDescription'),
            subDescription: t('invalidBreakTime'),
          });
          return;
        }
      } else {
        text = content.getCurrentContent().getPlainText('\n');
        const hasZeroBreakTime = ZERO_BREAK_TIME_REGEX.test(text);
        if (hasZeroBreakTime) {
          handleChangeOpenWrongBreakTimeDialog(true);
          return;
        }
      }

      // validate blackWords
      const plainText = text
        .replace(REGEX.ADVANCE_TAG, '')
        .replace(BREAK_TIME_REGEX, ' ');
      const blackWordsInText = blackWords.filter((blackWord) =>
        containsBlacklistedWords({
          text: plainText,
          blackWord,
          isNewHateSpeechDetectorEnabled,
        }),
      );
      const blackWordsInTextRegex = blackWordsInText.map((blackWord) =>
        blackWord.replaceAll(' ', ' +'),
      );
      if (blackWordsInText.length > 0) {
        const regex = !currentBrowser?.safariAgent
          ? new RegExp(
              `(?<![${VALID_LETTERS}])(${blackWordsInTextRegex.join(
                '|',
              )})(?![${VALID_LETTERS}])`,
              'gi',
            )
          : new RegExp(
              `(^|[^${VALID_LETTERS}])(${blackWordsInTextRegex.join(
                '|',
              )})([^${VALID_LETTERS}]|$)`,
              'gi',
            );

        const stateContent = EditorState.set(content, {
          decorator: new CompositeDecorator([
            {
              strategy: (contentBlock, callback) => {
                findWithRegexEditor(regex, contentBlock, callback);
              },
              component: BlackWordHighLight,
            },
            {
              strategy: getEntityStrategy('MUTABLE'),
              component: HightLightSpan,
            },
          ]),
        });
        handleChangeContent(stateContent);

        apis.warning.sendWarningInvalidRequest({
          text,
          invalidTexts: blackWordsInText,
          type: WARNING_REQUEST_TYPE.BLACK_WORD,
        });

        setOpenWrongSyntaxDialog({
          name: 'error-syntax',
          variant: 'warning',
          title: t('sentenceHasBlackWords'),
          description: t('sentenceHasBlackWordsDescription'),
        });
        return;
      }

      if (voice?.provider === VOICE_PROVIDER.VBEE) {
        const invalidTexts =
          text.match(
            currentBrowser?.safariAgent
              ? VALID_CHARACTERS_REGEX_SAFARI
              : VALID_CHARACTERS_LENGTH_REGEX,
          ) || [];
        const isValidText = VALID_CHARACTERS_REGEX.test(text);
        if (!isValidText) invalidTexts.push(text);

        if (invalidTexts?.length) {
          const invalidText = invalidTexts.join(', ');
          setOpenWrongSyntaxDialog({
            name: 'error-syntax',
            variant: 'warning',
            title: t('errorSyntax'),
            description: t('errorSyntaxDescription'),
            subDescription: t('invalidCharacter', { invalidText }),
          });
          apis.warning.sendWarningInvalidRequest({
            text,
            invalidTexts,
            type: WARNING_REQUEST_TYPE.CHARACTER_EXCEED,
          });
          return;
        }
      }

      if (isSSML) {
        if (checkValidXml(text)) {
          // TODO: map ssml to payload before call api
        } else setOpenSSMLDialog(true);
        return;
      }

      synthesisPayload = {
        ...synthesisPayload,
        text,
        paragraphs: advanceFeature && !openSentences ? paragraphs : undefined,
        voiceCode: voice?.code,
        speed: Number(synthesisRequest.speed),
      };
    }

    setLoading(false);

    // const isStandardData = getFeatureValue(
    //   FEATURE_KEYS.STANDARDIZATION_USER_DATA_MOE,
    // );
    // if (!isStandardData)
    //   window.dataLayer.push({
    //     event: EVENT_TYPE.STUDIO_CONVERT_TTS,
    //     userId: user?.id,
    //     email: user.email,
    //     requestType: 'requestTTS',
    //     voice: voice?.name,
    //     characters: inputLength,
    //     package: user.packageCode,
    //     remainingCharacters: user.remainingCharacters,
    //     packageExpiryDate: moment(user.packageExpiryDate).format(
    //       'DD/MM/YYY - HH:mm',
    //     ),
    //   });

    const options = {};
    const recaptchaTtsType = growthbook.getFeatureValue(
      FEATURE_KEYS.RECAPTCHA_TTS_TYPE,
    );

    let recaptchaToken;
    switch (recaptchaTtsType) {
      case RECAPTCHA_TYPE.V3:
        if (executeRecaptcha)
          recaptchaToken = await executeRecaptcha(RECAPTCHA_ACTION.SYNTHESIS);
        break;
      case RECAPTCHA_TYPE.ENTERPRISE:
        if (window.grecaptcha) {
          recaptchaToken = await window?.grecaptcha?.enterprise?.execute(
            RECAPTCHA_ENTERPRISE_SITE_KEY,
          );
        }
        break;
      default:
        break;
    }
    if (recaptchaToken) options.recaptchaToken = recaptchaToken;

    synthesisPayload.datasenses = datasenses.getDataSensesRequireFields();
    const data = await apis.synthesis.createSynthesis(
      synthesisPayload,
      options,
    );

    datasenses.sendMakeRequestEvent({
      userId: user.id,
      requestType: REQUEST_TYPE.STUDIO,
      voice: voice?.code,
      characters: inputLength,
      status: REQUEST_STATUS.IN_PROGRESS,
    });

    const { bitrate: bitrateResponse } = data.result || {};

    const newSynthesisRequest = {
      ...data.result,
      bitrate:
        bitrateResponse % 1000 === 0 ? bitrateResponse / 1000 : bitrateResponse,
      id: data.result?.requestId,
    };

    const hasSentences = data?.result?.sentences?.length > 0;
    const hasNoSentences = !hasSentences;

    const updateData = {
      title: newSynthesisRequest?.title || '',
      audioType: newSynthesisRequest.audioType,
      clientPause: newSynthesisRequest.clientPause || {},
      bitrate: newSynthesisRequest.bitrate,
      pronunciationDict: newSynthesisRequest.pronunciationDict || [],
      openSentences: hasSentences,
    };

    if (synthesisRequest.backgroundMusic?.link) {
      const {
        link,
        name,
        volume: currentVolume,
      } = synthesisRequest.backgroundMusic ?? {};
      updateData.backgroundMusic = { link, name, volume: currentVolume };
    }

    if (hasNoSentences) {
      updateData.voice = newSynthesisRequest.voice?.name;
      updateData.text = newSynthesisRequest.text || '';
      updateData.speed = newSynthesisRequest.speed;
    }
    if (hasSentences && data?.result?.sentences) {
      updateData.sentences = data.result.sentences.map((sentence) => ({
        breakTime: sentence?.breakTime,
        characters: sentence?.text?.length,
        speed: sentence?.speed,
        text: sentence?.text,
        voice_code: sentence.voiceCode,
      }));
    }
    dispatch(actions.synthesisRequest.updateDataRelatedRequest(updateData));
    dispatch(
      actions.synthesisRequest.updateSynthesisConfig(
        newSynthesisRequest,
        useNewUXSynthesis,
      ),
    );
    handleEnableEditor(false);
    setFlickerBackground(true);
    setLoading(false);
    if (data?.status) {
      handleChangeRequestLoading(true);
      // document.getElementById('requests').scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'end',
      //   inline: 'nearest',
      // });
    } else {
      const { errorMessage, errorCode } = data;
      switch (errorCode) {
        case ERROR_CODE.INVALID_SYNTAX: {
          setOpenWrongSyntaxDialog({
            name: 'error-syntax',
            variant: 'warning',
            title: t('errorSyntax'),
            description: t('errorSyntaxDescription'),
          });
          break;
        }

        case ERROR_CODE.SPAM_EMAIL: {
          setOpenWrongSyntaxDialogV2({
            name: 'error-syntax',
            variant: 'warning',
            title: t('cannotConvertTTS'),
            description: t('blockSpamEmailDescV2'),
          });
          break;
        }

        case ERROR_CODE.INACTIVE_VOICE: {
          const voiceName = openSentences
            ? [
                ...new Set(
                  synthesisSentences
                    .filter((sentence) => sentence.voice?.active === false)
                    .map((sentence) => sentence.voice?.name)
                    .filter(Boolean), // Filter out any undefined or null names
                ),
              ].join(', ') // Remove duplicates and join
            : voice?.name;
          dispatch(
            actions.noti.push({
              severity: 'error',
              message: t('inactiveVoiceNoti', { voiceName }),
              value: errorMessage,
            }),
          );
          break;
        }

        case ERROR_CODE.NO_MORE_SUPPORT_VOICE: {
          const userEOLDate = user?.studio?.oneTime?.eolDate;

          const voiceName = openSentences
            ? [
                ...new Set(
                  synthesisSentences
                    .filter((sentence) => {
                      const voiceEOLDate = sentence?.voice?.eolDate;
                      if (!voiceEOLDate || !userEOLDate) return true;

                      const latestEOLDate = new Date(
                        Math.max(
                          new Date(voiceEOLDate).getTime(),
                          new Date(userEOLDate).getTime(),
                        ),
                      );

                      return moment().isAfter(latestEOLDate);
                    })
                    .map((sentence) => sentence.voice?.name)
                    .filter(Boolean),
                ),
              ].join(', ')
            : voice?.name;

          dispatch(
            actions.noti.push({
              severity: 'error',
              message: t('inactiveVoiceNoti', { voiceName }),
              value: errorMessage,
            }),
          );
          break;
        }

        case ERROR_CODE.TEXT_TOO_LONG: {
          setOpenOutOfCreditsDialog(true);
          break;
        }

        default: {
          dispatch(
            actions.noti.push({
              severity: 'error',
              message:
                errorCode === ERROR_CODE.BAD_REQUEST
                  ? 'errorOccurred'
                  : 'synthesisFailure',
              value: errorMessage,
            }),
          );
        }
      }
    }
  };

  const handleConfirmNonVbeeDialog = async () => {
    setTriggerBtn(true);
    setOpenWrongSyntaxDialogV2(null);
  };

  const handleClickCharsFactorCheckbox = () => {
    if (!charsFactorCheckbox) {
      localStorage.setItem('nonVbeeDialog', true);
      localStorage.setItem('charsFactorDialog', true);
    } else {
      localStorage.removeItem('nonVbeeDialog');
      localStorage.removeItem('charsFactorDialog');
    }
    setCharsFactorCheckbox((value) => !value);
  };

  const handleCreateSynthesis = async (isDefaultText) => {
    if (isDefaultText) return;

    if (isSameToday(user?.createdAt))
      setTimeout(
        () =>
          dispatch(
            actions.banner.updateDisplayBanner(
              BANNER_TYPE.FIRST_BUY_PACKAGE_TRIAL,
              true,
            ),
          ),
        POPUP_TIME_OUT,
      );

    if (!checkValidCreateSynthesis()) return;
    await createSynthesisRequest();
  };

  const fetchVoicesByViLanguage = async () => {
    const data = await apis.voices.getVoices({
      languageCode: LANGUAGE_CODE.VIETNAMESE,
      active: true,
    });
    if (data.result) {
      const vietnameseVoices = data.result.voices;

      if (vietnameseVoices.length) {
        // setVoice(vietnameseVoices[0]);
        dispatch(actions.synthesisRequest.updateVoice(vietnameseVoices[0]));
      }
    }
  };

  const fetchVoicesByEnglishLanguage = async () => {
    const data = await apis.voices.getVoices({
      languageCode: ENGLISH_VOICE_CODES.toString(),
      active: true,
      sort: 'rank_asc',
    });
    if (data.result) {
      const englishVoices = data.result.voices;
      if (englishVoices.length) {
        // setVoice(englishVoices[0]);
        dispatch(actions.synthesisRequest.updateVoice(englishVoices[0]));
        dispatch(actions.voice.setDefaultGlobalVoice(englishVoices[0].code));
      }
    }
  };

  const fetchBlackWords = async () => {
    const data = await apis.blackWords.getBlackWords();
    if (data.result) {
      const blackWordsData = data.result.blackWords;
      setBlackWords(
        blackWordsData.map((blackWord) => blackWord.word?.toLowerCase()),
      );
    }
  };

  useEffect(() => {
    if (advanceFeature && !openSentences)
      setContent(EditorState.createEmpty(Decorator));
  }, [advanceFeature]);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < MOBILE_BREAKPOINT) history.push(ROUTES.MOBILE_TTS);
    };
    handleResize();
  }, []);

  useEffect(() => {
    let flickerTimeout;
    if (flickerBackground) {
      flickerTimeout = setTimeout(() => setFlickerBackground(false), 3000);
    }

    return () => clearTimeout(flickerTimeout);
  }, [flickerBackground]);

  const validateDataDraftConfig = (data) => {
    if (!Object.keys(data).length) return false;
    if (!data?.text && !data?.paragraphs?.length && !data?.sentences?.length)
      return false;
    return true;
  };

  const getVoiceExist = async (code, voiceOwnership) => {
    if (!code) return null;
    const voiceExist =
      isSynthesisVoiceCloning && voiceOwnership
        ? await apis.voices.getVoicesV2({ code, voiceOwnership })
        : await apis.voices.getVoices({ code });
    if (!voiceExist.status) return null;
    return voiceExist?.result?.voices[0];
  };

  const getVoiceDefault = async () => {
    const isVietNam = checkVietNam();
    const isUseFreePackage = user.packageCode === PACKAGE_CODE.STUDIO_FREE;

    const isCloningVoice = VC_VOICE_CODE_REGEX.test(voice?.code);
    let voiceOwnership;
    if (isCloningVoice) {
      voiceOwnership =
        voice?.status === VOICE_STATUS.USING
          ? VOICE_OWNERSHIP.PERSONAL
          : VOICE_OWNERSHIP.COMMUNITY;
      dispatch(
        actions.voice.changeFilterVoice({ voiceOwnership, ...filterVoice }),
      );
    }

    const voiceExist = await getVoiceExist(voice?.code, voiceOwnership);
    if (voiceExist) dispatch(actions.synthesisRequest.updateVoice(voiceExist));
    else if (isVietNam || isUseFreePackage || isSMSUser)
      fetchVoicesByViLanguage();
    else fetchVoicesByEnglishLanguage();
  };

  useEffect(() => {
    if (!useOldSaveDraftFeatureFlag) {
      const draftConfigSave = getDataLocalStorage(`dataDraft-${user.id}`) || {};
      const isValidDraftConfig = validateDataDraftConfig(draftConfigSave);
      if (isValidDraftConfig) {
        handleChangeCharacterExceed(!!draftConfigSave?.characterExceed);
        dispatch(actions.synthesisRequest.updateVoice(draftConfigSave.voice));
        dispatch(
          actions.synthesisRequest.updateSynthesisConfig(draftConfigSave),
        );
        dispatch(actions.synthesisRequest.updateLoadingSynthesisConfig(true));
        return;
      }
    }

    getVoiceDefault();

    dispatch(
      actions.synthesisRequest.updateSynthesisConfig(DEFAULT_SYNTHESIS_REQUEST),
    );
  }, []);

  useEffect(() => {
    currentIsPlayingAudio.current = isPlaying;
  }, [isPlaying]);

  useEffect(() => {
    currentReqPreviewId.current = requestPreviewId;
  }, [requestPreviewId]);

  useEffect(() => {
    runStreamAudioRef.current = isRunStreamAudio;
  }, [isRunStreamAudio]);

  const connectGetRemainingPreviewWS = () => {
    ws.current = new WebSocket(TTS_SYNTHESIS_URL);
    let pingInterval;
    ws.current.onopen = () => {
      ws.current.send(
        JSON.stringify({
          type: WS_TYPE.INIT,
          accessToken: keycloak?.token,
        }),
      );
      pingInterval = setInterval(() => {
        ws.current.send(JSON.stringify({ type: WS_TYPE.PING }));
      }, PING_INTERVAL);
    };

    ws.current.onmessage = (res) => {
      const responseData = camelcaseKeys(JSON.parse(res.data), { deep: true });
      const {
        type,
        remainingPreview: newRemainingPreview,
        usedFreePreviews: numberUsedFreePreviews = 0,
      } = responseData;

      if (type === WS_TYPE.INIT)
        ws.current.send(
          JSON.stringify({ type: WS_TYPE.GET_REMAINING_PREVIEW }),
        );

      if (type === WS_TYPE.GET_REMAINING_PREVIEW) {
        setRemainingPreview(newRemainingPreview);
        setUsedFreePreviews(numberUsedFreePreviews);
      }
    };

    ws.current.onclose = (event) => {
      const { code, reason, wasClean } = event;
      // eslint-disable-next-line no-console
      console.log('Websocket is closed.', { event, code, reason, wasClean });
      clearInterval(pingInterval);
    };
  };

  const connectSynthesisWS = async () => {
    const recaptchaTryListeningTtsType = growthbook.getFeatureValue(
      FEATURE_KEYS.RECAPTCHA_TRY_LISTEN_TTS_TYPE,
    );

    let recaptchaToken;
    switch (recaptchaTryListeningTtsType) {
      case RECAPTCHA_TYPE.V3:
        if (executeRecaptcha)
          recaptchaToken = await executeRecaptcha(RECAPTCHA_ACTION.SYNTHESIS);
        break;
      case RECAPTCHA_TYPE.ENTERPRISE:
        if (window.grecaptcha) {
          recaptchaToken = await window?.grecaptcha?.enterprise?.execute(
            RECAPTCHA_ENTERPRISE_SITE_KEY,
          );
        }
        break;
      default:
        break;
    }

    ws.current = new WebSocket(TTS_SYNTHESIS_URL);
    let pingInterval;
    ws.current.onopen = () => {
      ws.current.send(
        JSON.stringify({
          type: WS_TYPE.INIT,
          accessToken: keycloak?.token,
        }),
      );
      pingInterval = setInterval(() => {
        ws.current.send(JSON.stringify({ type: WS_TYPE.PING }));
      }, PING_INTERVAL);
    };

    const handleTryListeningError = () => {
      const failurePayload = { sentenceId: '', isAudioLoading: false };
      dispatch(actions.audioPlayer.updateTryListeningSentence(failurePayload));

      dispatch(
        actions.noti.push({
          severity: 'error',
          message: 'listeningError',
        }),
      );
      dispatch(actions.audioPlayer.updateRequestPreviewId(''));
    };

    ws.current.onmessage = (res) => {
      const responseData = camelcaseKeys(JSON.parse(res.data), { deep: true });
      const {
        type,
        result,
        status,
        remainingPreview: newRemainingPreview,
        usedFreePreviews: numberUsedFreePreviews = 0,
      } = responseData;

      if (status === 0) handleTryListeningError();
      if (type === WS_TYPE.INIT) {
        ws.current.send(
          JSON.stringify({
            type: WS_TYPE.SYNTHESIS,
            payload: previewPayload,
            accessToken: keycloak?.token,
            recaptchaToken,
          }),
        );

        // datasenses.sendPreviewEvent({
        //   userId: user.id,
        //   requestType: REQUEST_TYPE.STUDIO,
        //   voice: previewPayload.voiceCode,
        //   characters: previewPayload.text?.length || 0,
        //   status: REQUEST_STATUS.IN_PROGRESS,
        // });
      }
      if (type === WS_TYPE.SYNTHESIS) {
        switch (result && result.status) {
          case REQUEST_STATUS.IN_PROGRESS: {
            dispatch(
              actions.audioPlayer.updateRequestPreviewId(result.requestId),
            );
            break;
          }
          case REQUEST_STATUS.SUCCESS: {
            const getPublicAudioLink = async (requestId) => {
              const presignedAudioUrlResponse =
                await apis.requests.getPresignedAudioUrl(requestId);

              if (presignedAudioUrlResponse.status) {
                return presignedAudioUrlResponse.result.audio;
              }

              return null;
            };

            const playTryListeningAudio = async () => {
              ws.current.send(
                JSON.stringify({ type: WS_TYPE.GET_REMAINING_PREVIEW }),
              );
              if (currentReqPreviewId.current !== result.requestId) return;

              if (
                runStreamAudioRef.current &&
                checkFeaturePermission(
                  ttsUser.features,
                  FEATURE.STREAMING_PREVIEW,
                )
              ) {
                dispatch(
                  actions.audioPlayer.updateSelectedAudioRequest(
                    result?.requestId,
                  ),
                );
                dispatch(
                  actions.audioPlayer.updateFinalStreamAudio(result?.audioLink),
                );
                return;
              }

              if (
                currentIsPlayingAudio.current &&
                playAudioType === PLAYING_AUDIO_TYPE.SYNTHESIS
              ) {
                const cancelPayload = { sentenceId: '', isAudioLoading: false };
                dispatch(
                  actions.audioPlayer.updateTryListeningSentence(cancelPayload),
                );
              } else {
                const publicAudioLink = await getPublicAudioLink(
                  result?.requestId,
                );
                const audioLink = publicAudioLink || result?.audioLink;

                if (!showAudioPlayer)
                  dispatch(actions.audioPlayer.updateShowAudioPlayer(true));
                dispatch(actions.audioPlayer.updateAudioLink(audioLink, true));
                dispatch(actions.audioPlayer.updateSelectedAudioRequest(''));
                dispatch(
                  actions.audioPlayer.updateAudioType(
                    PLAYING_AUDIO_TYPE.SYNTHESIS,
                  ),
                );
                dispatch(
                  actions.audioPlayer.updateTryListeningSentence({ audioLink }),
                );
                dispatch(actions.audioPlayer.updateStatus(true));
              }
              dispatch(actions.audioPlayer.updateRequestPreviewId(''));
            };

            playTryListeningAudio();
            break;
          }
          case REQUEST_STATUS.FAILURE: {
            handleTryListeningError();
            break;
          }
          default:
            break;
        }
      }

      if (type === WS_TYPE.STREAM_REQUEST) {
        if (currentReqPreviewId.current !== result.requestId) return;
        if (
          currentIsPlayingAudio.current &&
          playAudioType === PLAYING_AUDIO_TYPE.SYNTHESIS
        ) {
          const cancelPayload = { sentenceId: '', isAudioLoading: false };
          dispatch(
            actions.audioPlayer.updateTryListeningSentence(cancelPayload),
          );
          return;
        }

        if (
          checkFeaturePermission(ttsUser.features, FEATURE.STREAMING_PREVIEW) &&
          isUseStreamingPreview
        ) {
          const { index, subIndex, audioLink, phrases, tts } = result;
          if (index !== undefined) {
            dispatch(
              actions.audioPlayer.updateStreamAudios({
                index,
                subIndex,
                audioLink,
                phrases,
                tts,
              }),
            );
          }
          if (index === 0 && subIndex === 0) {
            dispatch(actions.audioPlayer.updateStatusStreamAudio(true));
            dispatch(
              actions.audioPlayer.updateTryListeningSentence({
                isAudioLoading: false,
              }),
            );
            if (!showAudioPlayer)
              dispatch(actions.audioPlayer.updateShowAudioPlayer(true));
          }
        }
      }

      if (type === WS_TYPE.GET_REMAINING_PREVIEW) {
        setUsedFreePreviews(numberUsedFreePreviews);
        setRemainingPreview(newRemainingPreview);
      }
    };

    ws.current.onclose = (event) => {
      const { code, reason, wasClean } = event;
      // eslint-disable-next-line no-console
      console.log('Websocket is closed', { code, reason, wasClean });
      clearInterval(pingInterval);
    };
  };

  // Show dialog block download cause user already download
  const { showBlockDownloadDialog } = useSelector((state) => state.user);
  useEffect(() => {
    if (showBlockDownloadDialog) {
      setActionDialog({
        image: UpgradeImg,
        title: t('unableToDownload'),
        description: t('unableToDownloadDescription', { numberDownload: 1 }),
        onClose: () => {
          dispatch(actions.user.updateShowBlockDownloadDialog(false));
          handleCloseActionDialog();
        },
        actionComponents: renderUpgradeButton(),
      });
    }
  }, [showBlockDownloadDialog]);

  useEffect(() => {
    connectGetRemainingPreviewWS();
  }, []);

  useEffect(() => {
    if (isAudioLoading) {
      ws?.current?.close();
      connectSynthesisWS();
    }
  }, [isAudioLoading]);

  useEffect(() => {
    fetchBlackWords();
  }, []);

  const handleClickBuyPackages = () => {
    history.push(ROUTES.PAYMENT);
  };

  const renderCloseButton = (handleClose) => (
    <Button variant="contained" onClick={handleClose}>
      {t('understood')}
    </Button>
  );

  const renderCloseButtonV2 = (handleClose) => {
    switch (openWrongSyntaxDialogV2?.type) {
      case DIALOG_V2_TYPE.NON_VBEE_WARNING:
        return (
          <div className="non-vbee-warning">
            <FormControlLabel
              control={
                <Checkbox
                  classes={{ root: 'checkbox' }}
                  color="iconPrimary"
                  value={charsFactorCheckbox}
                  onChange={handleClickCharsFactorCheckbox}
                />
              }
              label={
                <Typography className="not-show-again-text">
                  {t('notShowAgain')}
                </Typography>
              }
              labelPlacement={t('notShowAgain')}
            />
            <div className="">
              <Button
                className="btn-non-vbee-warning"
                variant="outlined"
                onClick={handleClose}
              >
                {t('cancel')}
              </Button>
              <Button
                className="btn-non-vbee-warning"
                variant="contained"
                onClick={handleConfirmNonVbeeDialog}
              >
                {t('continueGenerate')}
              </Button>
            </div>
          </div>
        );
      case DIALOG_V2_TYPE.CANNOT_USE_VOICE:
        return (
          <Button
            className="btn-understood"
            variant="contained"
            onClick={() => {
              setOpenWrongSyntaxDialogV2(null);
            }}
          >
            {t('gotItV2')}
          </Button>
        );
      case DIALOG_V2_TYPE.RENAME_VOICE:
        return (
          <Button
            className="btn-understood"
            variant="contained"
            onClick={() => {
              setOpenWrongSyntaxDialogV2(null);
            }}
          >
            {t('gotIt')}
          </Button>
        );
      default:
        return (
          <Button
            className="btn-understood"
            variant="contained"
            onClick={handleClickBuyPackages}
          >
            {t('buyPackages')}
          </Button>
        );
    }
  };

  useEffect(() => {
    const doneTourGuide = localStorage.getItem(TTS_TOUR_GUIDE);
    if (!doneTourGuide && seenAllBanner && hasAgreedToTerms) {
      handleChangeRunTourGuide(true);
      localStorage.setItem(TTS_TOUR_GUIDE, true);
    }
  }, [seenAllBanner, hasAgreedToTerms]);

  useEffect(() => {
    if (limitedFeature) {
      setActionDialog({
        image: UpgradeImg,
        title: t('limitedFeature'),
        description: t('limitedFeatureDescription'),
        onClose: handleCloseLimitedFeatureDialog,
        actionComponents: renderUpgradeButton(),
      });
      dispatch(actions.dialog.displayDialog({ limitedFeature: false }));
    }
  }, [limitedFeature]);

  useEffect(
    () => () => {
      dispatch(actions.audioPlayer.resetAudioPlayer());
    },
    [],
  );

  useEffect(() => {
    if (screenHeight > HEIGHT_LARGE_SCREEN) {
      setIsExpandRequest(true);
    }
  }, [screenHeight]);

  const [closeMoreMenu, setCloseMoreMenu] = useState(false);
  useEffect(() => {
    if (!typeAICheck || !useAIEditor) return;
    const handleStrategy = (contentBlock, callback) => {
      const text = contentBlock.getText();
      wordsAIEditorChecked.forEach((word) => {
        const matches = [...text.matchAll(word)];
        dispatch(
          actions.synthesisRequest.updatePositionWords(
            matches?.map((m) => ({
              start: m?.index,
              decoratedText: m[0],
            })),
          ),
        );
        matches.forEach((match) =>
          callback(match.index, match.index + match[0].length),
        );
      });
    };

    const handleCheckText = () => {
      const stateContent = EditorState.set(content, {
        decorator: new CompositeDecorator([
          {
            strategy: handleStrategy,
            component: (word) => {
              if (
                skippedWord
                  ?.flatMap((e) => e?.start || [])
                  ?.includes(word?.start)
              ) {
                return word?.decoratedText;
              }
              return (
                <TooltipWrapper>
                  <StyledHightLightWord>
                    <div className={CLASS_WORD_BY_TYPE[typeAICheck]}>
                      {word?.children}
                    </div>
                  </StyledHightLightWord>
                </TooltipWrapper>
              );
            },
          },
        ]),
      });
      handleChangeContent(stateContent);
    };
    handleCheckText();
  }, [typeAICheck, useAIEditor, skippedWord, wordsAIEditorChecked]);

  const renderOutOfCreditsDialog = () => {
    const isPackageStandardV3 =
      usingPackage.level === PACKAGE_LEVEL_V3.STANDARD &&
      usingPackage.version === PACKAGE_STUDIO_VERSION.V3;

    const isPackageSpecialV3 =
      usingPackage.level === PACKAGE_LEVEL_V3.SPECIAL &&
      usingPackage.version === PACKAGE_STUDIO_VERSION.V3;

    const isPackageVipV3 =
      usingPackage.level === PACKAGE_LEVEL_V3.VIP &&
      usingPackage.version === PACKAGE_STUDIO_VERSION.V3;

    const isCustomPackage = checkCustomPackage({
      type: usingPackage?.type,
      level: usingPackage.level,
    });

    if (isCustomPackage) {
      return (
        <OutOfCreditsCustom
          open={openOutOfCreditsDialog}
          onClose={handleCloseOutOfCreditsDialog}
          packageCode={packageCode}
        />
      );
    }

    if (isPackageStandardV3) {
      return (
        <OutOfCreditsStandard
          open={openOutOfCreditsDialog}
          onClose={handleCloseOutOfCreditsDialog}
          packageCode={packageCode}
          voice={voice}
        />
      );
    }

    if (isPackageSpecialV3) {
      return (
        <OutOfCreditsSpecial
          open={openOutOfCreditsDialog}
          onClose={handleCloseOutOfCreditsDialog}
          packageCode={packageCode}
          voice={voice}
        />
      );
    }

    if (isPackageVipV3)
      return (
        <OutOfCreditsVip
          open={openOutOfCreditsDialog}
          onClose={handleCloseOutOfCreditsDialog}
          warningOneTimeCredits={warningOneTimeCredits}
        />
      );

    // Display this popup when using a free package or a package that is neither standard nor special v3.
    return (
      <OutOfCreditsFree
        open={openOutOfCreditsDialog}
        onClose={handleCloseOutOfCreditsDialog}
      />
    );
  };

  const renderMaxCharsLimitExceededDialog = () => {
    const isFreePackage = FREE_PACKAGE_CODES.includes(packageCode);

    if (isFreePackage) {
      return (
        <FreeMaxCharsLimitExceeded
          open={openMaxCharsLimitExceeded}
          onClose={handleCloseMaxCharsLimitExceededDialog}
          maxLengthInputText={maxLengthInputText}
        />
      );
    }

    return (
      <PaidMaxCharsLimitExceeded
        open={openMaxCharsLimitExceeded}
        onClose={handleCloseMaxCharsLimitExceededDialog}
        maxLengthInputText={maxLengthInputText}
      />
    );
  };

  return (
    <>
      <StyledTTS ref={TTSRef} showaudioplayer={showAudioPlayer}>
        {isNewHeaderUI && (
          <TitleBarNew
            isNewHeaderUI={isNewHeaderUI}
            loading={loading}
            characterExceed={characterExceed}
            inputLength={inputLength}
            isLoadDraft={loadDraft}
            onLoadEditContent={handleLoadContentEditor}
            onChangeInputLength={handleChangeInputLength}
            onOpenConfirmDialog={handleOpenDraft}
            content={content}
            enableEditor={enableEditor}
            onChangeRequestLoading={handleChangeRequestLoading}
            onEnableEditor={handleEnableEditor}
          />
        )}
        {/* Point to get Element scroll to top of the page */}
        <div id="scroll-point-top" className="scroll-point-top" />
        {!isNewHomepage && (
          <div ref={ttsRef} className="tts" id="request-editor">
            {loadingAIEditor && <AIEditor.LoadingCheckWord />}
            {[
              useLoadingLoadRequest,
              loadingLoadRequest,
              useNewTTSLayout,
              useNewRequestUI,
            ].every(Boolean) && (
              <div className="blur-tts">
                <CircularProgress
                  value={75}
                  className="loading-load-request"
                  size="24px"
                />
              </div>
            )}

            <Card flexDirection="column" padding="16px">
              {!isNewHeaderUI && (
                <TitleBar
                  loading={loading}
                  onCreateSynthesis={handleCreateSynthesis}
                  characterExceed={characterExceed}
                  inputLength={inputLength}
                  isLoadDraft={loadDraft}
                  onLoadEditContent={handleLoadContentEditor}
                  onChangeInputLength={handleChangeInputLength}
                  onOpenConfirmDialog={handleOpenDraft}
                  content={content}
                  enableEditor={enableEditor}
                  onCreateNewEditor={handleCreateNewEditor}
                  audioRef={audioRef}
                  onChangeRequestLoading={handleChangeRequestLoading}
                  onEnableEditor={handleEnableEditor}
                  setCloseMoreMenu={setCloseMoreMenu}
                  showNonVbeeWarning={showNonVbeeWarning}
                  showWarningFactorCharcterDialog={
                    showWarningFactorCharcterDialog
                  }
                />
              )}
              <ToolbarNew
                content={content}
                openSentences={openSentences}
                useNewDictionaryUI={useNewDictionaryUI}
                toolbarRef={toolbarRef}
                isSSML={isSSML}
                useNewTtsUI
                onOpenVoice={handleOpenVoices}
                handleChangeIsSSML={handleChangeIsSSML}
                handleChangeContent={handleChangeContent}
                onChangeInputLength={handleChangeInputLength}
                onChangeCharacterExceed={handleChangeCharacterExceed}
                onOpenSentences={handleOpenSentences}
                synthesisSentence={synthesisSentence}
                onTryListeningSentence={checkConditionPackageToPreview}
                audioRef={audioRef}
                enableEditor={enableEditor}
                onEnableEditor={handleEnableEditor}
                closeMoreMenu={closeMoreMenu}
                setCloseMoreMenu={setCloseMoreMenu}
              />
              <Content
                isSMSUser={isSMSUser}
                openSentences={openSentences}
                content={content}
                useNewRequestUI={useNewRequestUI}
                isSmallContent={isExpandRequest}
                inputLength={inputLength}
                toolbarRef={toolbarRef}
                characterExceed={characterExceed}
                requestTableHeight={requestTableHeight}
                onChangeContent={handleChangeContent}
                onChangeInputLength={handleChangeInputLength}
                onChangeCharacterExceed={handleChangeCharacterExceed}
                onchangeSynthesisSentence={handleChangeSynthesisSentence}
                onTryListeningSentence={checkConditionPackageToPreview}
                onChangeVoice={handleChangeVoice}
                audioRef={audioRef}
                synthesisSentence={synthesisSentence}
                enableEditor={enableEditor}
                onEnableEditor={handleEnableEditor}
                onResetContentEditor={handleResetContentEditor}
                onChangeExpandRequestTable={handleChangeIsExpandRequest}
                isNewHeaderUI={isNewHeaderUI}
              >
                {useAIEditor && !showSample && (
                  <AIEditor.ViewAmountWordChecked />
                )}
                <TitleBar
                  isNewLayout={1}
                  loading={loading}
                  showWarningFactorCharcterDialog={
                    showWarningFactorCharcterDialog
                  }
                  onCreateSynthesis={handleCreateSynthesis}
                  triggerBtn={triggerBtn}
                  onCancelTriggerBtn={() => setTriggerBtn(false)}
                  characterExceed={characterExceed}
                  inputLength={inputLength}
                  isLoadDraft={loadDraft}
                  onLoadEditContent={handleLoadContentEditor}
                  onChangeInputLength={handleChangeInputLength}
                  onOpenConfirmDialog={handleOpenDraft}
                  content={content}
                  enableEditor={enableEditor}
                  onCreateNewEditor={handleCreateNewEditor}
                  audioRef={audioRef}
                  onChangeRequestLoading={handleChangeRequestLoading}
                  onEnableEditor={handleEnableEditor}
                  setCloseMoreMenu={setCloseMoreMenu}
                  showNonVbeeWarning={showNonVbeeWarning}
                  isNewHeaderUI={isNewHeaderUI}
                  showWarningCannotUseVoiceDialog={
                    showWarningCannotUseVoiceDialog
                  }
                />
              </Content>

              {isNewPopupChooseVoise && openVoices ? (
                <VoicesDialogNew
                  open={openVoices}
                  activeVoiceId={voice && voice.id}
                  activeVoiceCode={voice && voice.code}
                  enableEditor={enableEditor}
                  onClose={handleCloseVoices}
                  onChangeVoice={handleChangeVoice}
                  hasLanguageFilter={!isSMSUser}
                />
              ) : (
                openVoices && (
                  <VoicesDialog
                    open={openVoices}
                    activeVoiceId={voice && voice.id}
                    activeVoiceCode={voice && voice.code}
                    enableEditor={enableEditor}
                    onClose={handleCloseVoices}
                    onChangeVoice={handleChangeVoice}
                    hasLanguageFilter={!isSMSUser}
                  />
                )
              )}
            </Card>
          </div>
        )}

        <div
          style={{ height: '100%' }}
          className="request"
          ref={requestTableRef}
          id="requests"
        >
          <Card
            flexDirection="column"
            margin-top="4px"
            padding={!isNewHomepage ? '4px 16px 0px 16px' : '0px'}
          >
            {useNewRequestUI ? (
              <NewRequest
                onClickAddRequest={onClickAddRequest}
                isNewHomepage={isNewHomepage}
                requestListHeight={useElementHeight(requestTableRef)}
                flickerBackground={flickerBackground}
                isExpand={isNewHomepage || isExpandRequest}
                useNewRequestUI={useNewRequestUI}
                requestLoading={requestLoading}
                onChangeRequestLoading={handleChangeRequestLoading}
                onChangeIsExpand={handleChangeIsExpandRequest}
                onEnableEditor={handleEnableEditor}
                audioRef={audioRef}
              />
            ) : (
              <Requests
                isExpand={isExpandRequest}
                requestLoading={requestLoading}
                onChangeRequestLoading={handleChangeRequestLoading}
                onChangeIsExpand={handleChangeIsExpandRequest}
                onEnableEditor={handleEnableEditor}
                audioRef={audioRef}
              />
            )}
          </Card>
        </div>

        {useOldSaveDraftFeatureFlag && (
          <ConfirmDialog
            title={t('note')}
            content={t('reloadPreviousWorkContent')}
            open={openDraft}
            onClose={handleCloseDraft}
            onConfirm={handleLoadDraft}
            confirmDataId="reload-prev-session"
            closeDataId="not-reload-prev-session"
          />
        )}

        <ConfirmDialog
          title={t('confirmSwitchProcessingMethod')}
          content={t('switchProcessingMethodNote')}
          open={confirmSwitchParagraph}
          closeDataId="cancel-unsplit-para"
          confirmDataId="confirm-unsplit-para"
          onClose={handleCloseConfirmDialog}
          onConfirm={handleAcceptConfirmDialog}
        />

        <NotificationDialog
          name="ssml"
          title={t('convertTTSBySSML')}
          description={t('inValidSSML')}
          variant="warning"
          open={openSSMLDialog}
          onClose={handleCloseSSMLDialog}
          actionComponent={renderCloseButton(handleCloseSSMLDialog)}
        />

        {runTourGuide && (
          <NewTourGuide
            stepsGuide={stepsGuide}
            run={runTourGuide}
            onChangeRunTourGuide={handleChangeRunTourGuide}
            stepDisplay={false}
          />
        )}

        <NotificationDialog
          name="break-time"
          title={t('errorSyntax')}
          description={t('errorInvalidBreakTimeDesc')}
          variant="warning"
          open={openWrongBreakTimeDialog}
          onClose={() => handleChangeOpenWrongBreakTimeDialog(false)}
          actionComponent={renderCloseButton(() =>
            handleChangeOpenWrongBreakTimeDialog(false),
          )}
        />

        <NotificationDialog
          name={openWrongSyntaxDialog?.name}
          title={openWrongSyntaxDialog?.title}
          description={openWrongSyntaxDialog?.description}
          subDescription={openWrongSyntaxDialog?.subDescription}
          variant={openWrongSyntaxDialog?.variant}
          open={!!openWrongSyntaxDialog?.title}
          onClose={() => setOpenWrongSyntaxDialog(null)}
          actionComponent={renderCloseButton(() =>
            setOpenWrongSyntaxDialog(null),
          )}
        />

        <NotificationDialogV3
          name={openWrongSyntaxDialogV2?.name}
          title={openWrongSyntaxDialogV2?.title}
          description={openWrongSyntaxDialogV2?.description}
          subDescription={openWrongSyntaxDialogV2?.subDescription}
          variant={openWrongSyntaxDialogV2?.variant}
          open={!!openWrongSyntaxDialogV2?.title}
          onClose={() => setOpenWrongSyntaxDialogV2(null)}
          actionComponent={renderCloseButtonV2(() =>
            setOpenWrongSyntaxDialogV2(null),
          )}
        />

        {!!openDialogLockedCycle?.title && (
          <NotificationDialogV4
            image={LockCycle}
            title={openDialogLockedCycle?.title}
            description={openDialogLockedCycle?.description}
            actionComponent={renderLockedCycleButton()}
            open={!!openDialogLockedCycle?.title}
            onClose={() => setOpenDialogLockedCycle(null)}
          />
        )}

        {actionDialog?.title && (
          <ActionDialog
            image={actionDialog?.image}
            open={!!actionDialog?.title}
            title={actionDialog?.title}
            description={actionDialog?.description}
            onClose={actionDialog?.onClose}
            actionComponents={actionDialog?.actionComponents}
          />
        )}

        <ExpiredPackageAlert
          open={openExpiredPackageDialog}
          onClose={handleCloseExpiredPackageDialog}
        />

        {renderMaxCharsLimitExceededDialog()}

        {renderOutOfCreditsDialog()}
      </StyledTTS>

      <AudioPlayer isNewLayoutTTS={useNewRequestUI} audioRef={audioRef} />
    </>
  );
};

export default TTSNew;
